import { render, staticRenderFns } from "./providerConfigForm.vue?vue&type=template&id=21619409&scoped=true&"
import script from "./providerConfigForm.vue?vue&type=script&lang=babel&"
export * from "./providerConfigForm.vue?vue&type=script&lang=babel&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21619409",
  null
  
)

export default component.exports